export default function Loader({ text = "Please wait..." }) {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
      
      {/* Loader Container */}
      <div className="flex flex-col items-center gap-6">
        
        {/* Logo */}
        <img 
          src="/logo512.png" 
          alt="App Logo" 
          className="h-16 w-auto animate-pulse"
        />

        {/* Spinner */}
        <div className="relative">
          <div className="h-12 w-12 rounded-full border-4 border-gray-200"></div>
          <div className="absolute inset-0 h-12 w-12 rounded-full border-4 border-green-600 border-t-transparent animate-spin"></div>
        </div>

        {/* Text */}
        <p className="text-gray-600 text-sm sm:text-base font-medium text-center">
          {text}
        </p>

      </div>
    </div>
  );
}
